import { Injectable } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    public fileAddingComplete$: Observable<boolean>;
    private file: File;
    private uploader: FileUploader;
    private fileName: string;
    private fileAddingCompleteSubject: Subject<boolean>;

    constructor() {
        this.fileAddingCompleteSubject = new Subject<boolean>();
        this.fileAddingComplete$ =
            this.fileAddingCompleteSubject.asObservable();
        this.uploader = new FileUploader({ url: '' });
    }

    get uploadedFile(): File {
        return this.file;
    }

    get uploadedFileName(): string {
        return this.fileName ? this.fileName : '';
    }

    get fileUploader(): FileUploader {
        return this.uploader;
    }

    initialize() {
        this.uploader.onAfterAddingFile = (fileItem) => {
            // Since we are doing single file upload
            this.uploader.clearQueue();
            fileItem.withCredentials = false;
            this.fileName = fileItem.file.name;
            // TODO: Validate file extension with the passed file
            this.file = fileItem._file;
            this.fileAddingCompleteSubject.next(true);
        };
    }

    clearUpload() {
        this.fileName = null;
        this.uploader.clearQueue();
    }
}
